module.exports = __webpack_public_path__ + "static/img/naniungo-menu-executives.414014a1.jpg";